export default
    {
        guarda: "/irsp/guarda",
        list: "/irsp/list",
        printEvento: "/irsp/imprime",
        printReporte: "/irsp/reporte",

        guardaEvidencia: "/irsp/guardaEvidencia",
        listEvidencias: "/irsp/listEvidencias",
        getEvidencia: "/irsp/getEvidencia",
    }
